import VPagination from '../VPagination.vue';

export default {
    components: { VPagination },

    data() {
        return {
            fetchingEvent: false,
            events: { data: [] },
            currentPage: 1,
        };
    },

    computed: {
        eventIsEmpty() {
            return this.events.data.length === 0;
        },

        totalPage() {
            return Math.ceil(this.events.total / 20);
        },
    },

    created() {
        this.fetchEvent();
    },

    methods: {
        eventUrl(event) {
            return route('event.show', event.slug);
        },

        hasBaseImage(event) {
            return Object.keys(event.files).length !== 0;
        },

        baseImage(event) {
            if (this.hasBaseImage(event)) {
                return event.files[0].path;
            }

            return `${window.FleetCart.baseUrl}/themes/storefront/public/images/image-placeholder.png`;
        },

        fetchEvent() {
            this.fetchingWishlist = true;

            $.ajax({
                method: 'GET',
                url: route('event.index', {
                    page: this.currentPage,
                }),
            }).then((events) => {
                this.events = events;
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.fetchingEvent = false;
            });
        },

        changePage(page) {
            this.currentPage = page;

            this.fetchEvent();
        },
    },
};
